import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "name", "description", "counts"]

  connect() {
    this.update()
  }

  update() {
    const option = this.selectTarget.selectedOptions[0]
    if (!option || !this.hasNameTarget) return

    this.nameTarget.textContent = option.textContent
    this.descriptionTarget.textContent = option.dataset.description || ""
    this.countsTarget.textContent = option.dataset.counts || ""
  }
}
